<template>
  <div>
    <div>
      <ul class="nav-list">
        <li class="nav-item" v-for="(tab, index) in tabs" :key="index" :class="{ 'active': tab.isActive }">
          <a :href="tab.href" data-action="open_tab" :data-tab="tab.dataTab" @click="selectTab(tab)">{{ tab.name }}</a>
        </li>
      </ul>
    </div>
    <div class="tabs-details">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return { tabs: [] }
  },
  created() {
    this.tabs = this.$children
  },
  methods: {
    selectTab(selectedTab) {
      this.tabs.forEach(tab => {
        tab.isActive = tab.name == selectedTab.name
      })
      this.$emit("is-active", selectedTab.name)
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-list {
  list-style: none;
  padding: 0;
  margin: 0;
  border-bottom: 4px solid $color-inactive;
  display: flex;
  .nav-item {
    @extend %font-size-s;
    text-align: center;
    width: 100%;
    font-weight: bold;
    a {
      padding: 12px 0;
      display: block;
      text-decoration: none;
      color: $color-secondary;
    }
  }
  .active {
    position: relative;
    font-weight: bold;
    &:after {
      content: "";
      position: absolute;
      bottom: -4px;
      left: 0;
      width: 100%;
      -webkit-animation: widthAnimate 0.3s; /* Safari, Chrome and Opera > 12.1 */
      -moz-animation: widthAnimate 0.3s; /* Firefox < 16 */
      -ms-animation: widthAnimate 0.3s; /* Internet Explorer */
      -o-animation: widthAnimate 0.3s; /* Opera < 12.1 */
      animation: widthAnimate 0.3s;
      background-color: $color-orange-finno;
      height: 4px;
    }
    a {
      color: $color-secondary;
    }
  }
}
</style>
